import type {TicketLabel} from '../types/ticket';

/**
 * Ticket labels are Forecast's shared `Label`, whose `name` and `color` are
 * nullable in the schema. Only `name` can really be missing (the column is
 * nullable; `color` is not), but both are normalised here so every consumer of
 * {@link TicketLabel} can treat them as plain strings.
 *
 * The fallbacks are display-only: label writes go by id, so neither can leak
 * back to the server.
 */
export const UNTITLED_LABEL_NAME = 'Untitled label';

// A CSS value rather than a hex: the dot takes the surrounding text colour, which
// is neutral on every surface and needs no theme lookup outside styled-components.
export const DEFAULT_LABEL_COLOR = 'currentColor';

/** A label's name as shown to the reader — never blank, never "null". */
export function labelDisplayName(label: {readonly name?: string | null}): string {
	return label.name?.trim() ? label.name : UNTITLED_LABEL_NAME;
}

export function toTicketLabel(label: {
	readonly id: string;
	readonly name?: string | null;
	readonly color?: string | null;
}): TicketLabel {
	return {
		id: label.id,
		name: labelDisplayName(label),
		color: label.color ?? DEFAULT_LABEL_COLOR,
	};
}
